import { Link } from 'react-router-dom';

const CATEGORY_LINKS = [
  { label: '电影', to: '/category/movie' },
  { label: '电视剧', to: '/category/tv' },
  { label: '热门推荐', to: '/category/hot' },
];

const HELP_LINKS = [
  { label: '影视资讯', to: '/news' },
  { label: '关于我们', to: '/about' },
  { label: '搜索资源', to: '/search' },
];

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-900 text-primary-100">
      <div className="mx-auto grid max-w-[1280px] gap-8 px-4 py-12 md:px-6 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-background-50">
              <i className="ri-movie-2-line text-lg" />
            </span>
            <span className="font-heading text-xl font-bold text-background-50">91爱爱</span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-primary-200">
            91爱爱是最新影视资源与影视资讯平台，覆盖电影、电视剧等多种类型，为影视爱好者提供便捷的查找、浏览与资讯阅读体验。
          </p>
        </div>

        <div>
          <h3 className="font-heading text-base font-semibold text-background-50">影视分类</h3>
          <ul className="mt-4 space-y-3 text-sm">
            {CATEGORY_LINKS.map((item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  className="inline-flex items-center gap-1.5 text-primary-200 transition-colors hover:text-accent-300"
                >
                  <i className="ri-arrow-right-s-line" />
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-heading text-base font-semibold text-background-50">快速导航</h3>
          <ul className="mt-4 space-y-3 text-sm">
            {HELP_LINKS.map((item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  className="inline-flex items-center gap-1.5 text-primary-200 transition-colors hover:text-accent-300"
                >
                  <i className="ri-arrow-right-s-line" />
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-heading text-base font-semibold text-background-50">联系我们</h3>
          <ul className="mt-4 space-y-3 text-sm text-primary-200">
            <li className="flex items-start gap-2">
              <i className="ri-mail-line mt-0.5 text-accent-300" />
              contact@91aiai.example.com
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-phone-line mt-0.5 text-accent-300" />
              400-000-9191（工作日 9:00-18:00）
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-map-pin-line mt-0.5 text-accent-300" />
              本站为演示站点，内容均为虚构示例
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-800">
        <div className="mx-auto flex max-w-[1280px] flex-col gap-3 px-4 py-5 text-xs text-primary-300 md:flex-row md:items-center md:justify-between md:px-6">
          <p>© 2026 91爱爱 影视资讯平台 · 本站所有影视信息均为演示数据，不提供播放与下载服务。</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <span>内容仅供学习交流</span>
            <span className="hidden h-3 w-px bg-primary-700 md:inline-block" />
            <span>备案信息以实际发布为准</span>
          </p>
        </div>
      </div>
    </footer>
  );
}